import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { TranslationKeys } from '../../enums/translationKeys';

const TurboModePopUp = observer(({ t, handleIsShowChange }) => {
  const [isAnim, setIsAnim] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsAnim(true), 3000);
  }, []);

  return (
    <div className='turbo-mode-modal-overlay'>
      <div className='turbo-mode-modal'>
        <h4 className='turbo-mode-modal-title'>{t(TranslationKeys.TurboMode)}</h4>
        <p className='turbo-mode-modal-paragraph'>{t(TranslationKeys.TurboModePopUp)}</p>
        <button
          type='button'
          data-label={t(TranslationKeys.OK)}
          onClick={() => handleIsShowChange(true)}
          className='turbo-mode-modal-button'
        />
      </div>
      <div className={`turbo-mode-animation ${isAnim ? 'start-anim' : ''}`}>
        <div className='turbo-mode-animation-target'>
          <div className='turbo-mode-anim-label'>{t(TranslationKeys.Turbo)}</div>
          <div className='turbo-mode-anim-circle'>
            <span className='turbo-mode-wave' />
          </div>
        </div>
        <div className='turbo-mode-anim-hand' />
      </div>
    </div>
  );
});

export default TurboModePopUp;
